import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import "../styles/components/movieDetails.scss";
import Footer from '../components/footer';
import Header from '../components/header';

const Categories = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        axios.get(`https://api.themoviedb.org/3/genre/movie/list?api_key=${process.env.REACT_APP_TMDB_API_KEY}&language=fr-FR`)
            .then((res) => setData(res.data.genres))
            .catch((error) => console.error("Erreur lors de la récupération des genres :", error));
    }, []);

    const categories = [
        { id: '12', title: 'Aventure', description: 'Exploration et découvertes', image: 'aventure.jpg' },
        { id: '10751', title: 'Familial', description: 'Divertissement tous âges', image: 'familial.jpg' },
        { id: '18', title: 'Drame', description: 'Émotions et relations', image: 'drame.jpg' },
        { id: '28', title: 'Action', description: 'Action et suspense', image: 'action.jpg' },
        { id: '80', title: 'Crime', description: 'Enquêtes et malfaiteurs', image: 'crime.jpg' },
        { id: '27', title: 'Horreur', description: 'Peur et suspense', image: 'horreur.jpg' },
        { id: '37', title: 'Western', description: 'Frontières sauvages', image: 'western.jpg' },
        { id: '878', title: 'Science-Fiction', description: 'Exploration futuriste', image: 'science-Fiction.jpg' },
        { id: '35', title: 'Comédie', description: 'Rires et humour', image: 'comédie.jpg' },
        { id: '10749', title: 'Romance', description: 'Relations sentimentales', image: 'romance.jpg' },
        { id: '10770', title: 'Téléfilm', description: 'Production télévisuelle', image: 'téléfilm.jpg' },
        { id: '14', title: 'Fantastique', description: 'Univers magiques', image: 'fantastique.jpg' },
        { id: '9648', title: 'Mystère', description: 'Énigmes et révélations', image: 'mystere.jpg' },
        { id: '10752', title: 'Guerre', description: 'Batailles et stratégies', image: 'guerre.jpg' },
        { id: '53', title: 'Thriller', description: 'Suspense', image: 'thriller.jpg' },
        { id: '10402', title: 'Musique', description: 'Performances musicales', image: 'musique.jpg' },
        { id: '36', title: 'Histoire', description: 'Événements historiques', image: 'histoire.jpg' },
        { id: '99', title: 'Documentaire', description: 'Récits et réalités', image: 'documentaire.jpg' },
        { id: '16', title: 'Animation', description: 'Imagination sans limite', image: 'animation.jpg' },
    ];

    return (
        <div>
            <Header />
            <main>
                <section className="header_acteur">
                    <div className="detail-categories">
                        <h1>CATÉGORIES</h1>
                        <div className="container">
                            <div className="row">
                                {categories.map(category => (
                                    <div key={category.id} className="col-6 col-sm-6 col-md-4 col-lg-4 mb-4 col-xl-2 col-xxl-2">
                                        <div className="card">
                                            <div className="card__content">
                                                <h2>{category.title}</h2>
                                                <p>{category.description}</p>
                                                <Link to={`/categorie/${category.id}/${category.title}`} className="btn btn-primary">Découvrir +</Link>
                                                <div className="card__content-bg"></div>
                                                <img src={`/categories/${category.image}`} alt={category.title} />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
};

export default Categories;
